import * as React from "react";
import type { SVGProps } from "react";
const SvgCheck2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M11.947 3.164c.186.155.211.43.056.616l-5.833 7a.44.44 0 0 1-.645.03l-3.5-3.5a.437.437 0 1 1 .618-.62l3.162 3.162L11.33 3.22a.44.44 0 0 1 .616-.056"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCheck2;
